import {handleBody, handleExceptions, GET, createArrayEndpoint} from '../utils/api';

export const getDirectory = (data: {
  city: string;
  state: string;
  country: string;
  catgory: string;
}) => {
  const endpoint = createArrayEndpoint('directories/search', {...data});

  return GET(endpoint).then((response) => {
    if (response.status >= 400) {
      return handleExceptions(response);
    }

    return handleBody(response);
  });
};
